import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { RefreshTokenInterceptor } from "shared/interceptors/refresh-token.interceptor";

export const RefreshTokenInterceptorProvider = {
    provide: HTTP_INTERCEPTORS,
    useClass: RefreshTokenInterceptor,
    multi: true
  }